import { render, staticRenderFns } from "./EmployeeStatistical.vue?vue&type=template&id=ec70617a&scoped=true"
import script from "./EmployeeStatistical.vue?vue&type=script&lang=js"
export * from "./EmployeeStatistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70617a",
  null
  
)

export default component.exports